// 총 2개의 router를 만든다. 로그인된 사람 Router, 로그아웃된 사람 Router

import React from 'react';
import theme from './styles/theme';
import './styles/main.scss';
//Client Cache에 Local State 요청
import { ReactRouter } from './routers/reactrouter';
import { ThemeProvider } from 'styled-components';

function App() {
    return (
        <>
            <ThemeProvider theme={theme}>
                <ReactRouter />
            </ThemeProvider>
        </>
    );
}

export default App;
